import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';
import { PortActionSuccess, PortActionFailure } from '../../../types/types';
import { green, orange, red } from '@mui/material/colors';

interface DialogContentBatchResultProps {
  waitBlock: boolean;
  succeeded: PortActionSuccess[];
  failed: PortActionFailure[];
}

const DialogContentBatchResult: React.FC<DialogContentBatchResultProps> = ({
  waitBlock,
  succeeded,
  failed,
}) => {
  return (
    <>
      <WarningIcon sx={{ fontSize: 50, color: orange[500], marginTop: 1 }} />
      <Stack spacing={2}>
        <Typography variant="body1">Your action was partially successful.</Typography>
        <Box>
          <Typography variant="body2" fontWeight="bold" color={green[700]}>
            Succeeded ({succeeded.length})
          </Typography>
          {succeeded.map((s) => (
            <Box key={s.serial}>
              <Typography variant="body2">
                <Box component="span" fontWeight="bold">
                  device serial: {s.serial}
                </Box>
                {Array.isArray(s.ports) ? `, ports: ${s.ports.join(', ')}` : `, port: ${s.ports}`}
              </Typography>
            </Box>
          ))}
          {waitBlock && (
            <Typography variant="body2" color="text.secondary">
              Execution on the network side will finish{' '}
              <Box component="span" fontWeight="bold">
                in a minute or two.
              </Box>
            </Typography>
          )}
        </Box>
        <Box>
          <Typography variant="body2" fontWeight="bold" color={red[700]}>
            Failed ({failed.length})
          </Typography>
          {failed.map((f) => (
            <Box key={f.serial}>
              <Typography variant="body2">
                <Box component="span" fontWeight="bold">
                  device serial: {f.serial}
                </Box>
                {Array.isArray(f.ports) ? `, ports: ${f.ports.join(', ')}` : `, port: ${f.ports}`}{' '}
                <Box component="span" color="text.secondary">
                  - status code: {f.status_code}
                </Box>
              </Typography>
            </Box>
          ))}
        </Box>
      </Stack>
    </>
  );
};

export default DialogContentBatchResult;
